//jshint esverion :6
import '../styles/Navbar.css';
function Navbar() {
  return (
    <div id='navbar' class='transparent'>
      <nav class='navbar navbar-expand-lg '>
        <div class='container-fluid'>
          <h1 class='r navbar-brand link-light' href=''>
            <h3>Hardik Agarwal </h3>
            <h6>
              <i
                class='fas fa-map-marker-alt'
                style={{ marginRight: '10px' }}></i>
              open to work
            </h6>
          </h1>
          <button
            class='navbar-toggler'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarSupportedContent'
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'>
            <span class='navbar-toggler-icon'>
              <i class='fas fa-bars'></i>
            </span>
          </button>
          <div class='collapse navbar-collapse' id='navbarSupportedContent'>
            <ul class='navbar-nav ms-auto mb-2 mb-lg-0'>
              <li class='nav-item'>
                <a
                  class='x nav-link active link-light'
                  aria-current='page'
                  href='#about'>
                  about
                </a>
              </li>
              <li class='nav-item'>
                <a
                  class='x nav-link active link-light'
                  aria-current='page'
                  href='https://drive.google.com/file/d/1c4Ogxk7t3O0to-h9rO9wvCM0FnAJnD47/view?usp=sharing'>
                  resume
                </a>
              </li>
              <li class='nav-item'>
                <a class='x nav-link link-light' href='#projects'>
                  projects
                </a>
              </li>
              <li class='nav-item'>
                <a class='x nav-link link-light' href='#footer'>
                  contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
